import { ItemsAdministrativeInfo } from './configuration';
import { Edition } from './edition';
import { Feature, OptionInfo } from './feature';
import { Customer, CustSuppData } from './customer';

export class IndustryDescription {
    Versioning: number;
    ProductID: string = IndustryProductID.MC;
    ModuleCode: string;
    TranslatedName: string;
    Description: string;
    MinCal: number;
    IndustryEditions: Edition[];
    PriceRanges: ItemsAdministrativeInfo[] = [];
    SASPriceRanges: ItemsAdministrativeInfo[] = [];
    MLUPriceRanges: ItemsAdministrativeInfo[] = [];
    public Features: Feature[] = [];
    public OptionalFeatures: Feature[] = [];
    public CountableFeatures: Feature[] = [];
    public PptFeatures: Feature[] = [];
    public Caltypes: CalTypeObject[];
    public PaymentPeriodicity: number;
}

export class IndustryCal {
    industryCode: string;
    editionCode: string;
    caltypes: CalTypeObject[];
}

export class CalTypeObject {
    CalType: number;
    Fragment: string;
    TranslatedName: string;
    Description: string;
    EditionCode: string;
    IndustryCode: string;
    MinCal: number;
    NrCalBuyed: number;
}
export enum IndustryCalType {
    CalFull = 1,
    CalWMSMobile = 2,
    CalManufacturingMobile = 3,
    CalInStore = 4,
    CalCRMSALES = 5,
    CalCRMFULL = 6,
    CalMYMS = 7,
    CalTCCN = 8,
    CalEPCN = 9,
    CalMC01 = 10,
    CalCRMM = 11,
    CalKPM = 12,
    CalMPCN = 13,
    CalOECO = 14,
    CalTLCN = 15,
}

export class IndustryPurchasedInfo {
    ModuleCode: string;
    Version: string;
    TranslatedName: string;
    Edition: Edition;
    productCode: string = '';
    productID: string = '';
    applicationList: string = '';
    db: number = 2; //postgress
    caltypes: CalTypeObject[] = [];
    Country: string;
    gwamAccountEmail: string;
    gwamAccount: string;
    paymentModality: number;
    SelectedFeatures: Feature[] = [];
    OptionalFeatures: Feature[] = [];
    PptFeatures: Feature[] = [];
    CountableFeatures: Feature[] = [];
    SelectedFeaturesOptionInfo: OptionInfo[] = [];
    OptionalFeaturesOptionInfo: OptionInfo[] = [];
    priceRanges: ItemsAdministrativeInfo[] = [];
    MLUPriceRanges: ItemsAdministrativeInfo[] = [];
    Customer: Customer;
    BillingTo: CustSuppData;
    SubscriptionKey: string = '';
    paymentPeriodicity: number;
    cartRowID: string;
    expirationDate: string;
    SubscriptionMode: string = '';
    instanceKey: string = '';
    instanceType: string = '';
    BillingToPartner = false;
    industryBaseAmount: number = 0;
    industryTotalBaseAmount: number = 0;
    industryBaseOptionAmount = 0;
    totalOptionalFeaturesAmount: number = 0;
    totalCountableModuleAmount: number = 0;
    totalCALAmount: number = 0;
    totalGrossAmount: number = 0;
    totalMLUAmount: number = 0;
    mluIndustryBaseAmount: number = 0;
    mluTotalOptionalFeaturesAmount: number = 0;
    mluTotalCountableModuleAmount: number = 0;
    mluTotalCALAmount: number = 0;
    mluAccrualAmount: number = 0;
    IsPPUConfiguration: boolean = false;
    SnapshotID: string;
}
export class SetIndustryPurchasedInfo {
    public static createIndustryPurchasedInfo(industry: IndustryDescription, currIndustryPurchInfo: IndustryPurchasedInfo) {
        currIndustryPurchInfo.ModuleCode = industry.ModuleCode;
        currIndustryPurchInfo.Version = industry.Versioning.toString();
        currIndustryPurchInfo.TranslatedName = industry?.TranslatedName;
        currIndustryPurchInfo.productCode = '';
        currIndustryPurchInfo.productID = industry.ProductID;
        currIndustryPurchInfo.db = 2; //unknown
        currIndustryPurchInfo.caltypes = industry.Caltypes;
        currIndustryPurchInfo.Country = '';
        currIndustryPurchInfo.gwamAccount = '';
        currIndustryPurchInfo.paymentModality = 0;
        currIndustryPurchInfo.SelectedFeatures = [];
        currIndustryPurchInfo.OptionalFeatures = [];
        currIndustryPurchInfo.PptFeatures = [];
        currIndustryPurchInfo.SelectedFeaturesOptionInfo = [];
        currIndustryPurchInfo.OptionalFeaturesOptionInfo = [];
        currIndustryPurchInfo.priceRanges = industry.PriceRanges;
        currIndustryPurchInfo.Customer = currIndustryPurchInfo.Customer;
        currIndustryPurchInfo.totalGrossAmount = 0;
        currIndustryPurchInfo.totalMLUAmount = 0;
        currIndustryPurchInfo.industryBaseAmount = 0;
        currIndustryPurchInfo.paymentPeriodicity = 1; //express in month
        currIndustryPurchInfo.cartRowID = '';
        currIndustryPurchInfo.expirationDate = new Date().toISOString();
    }
}
export class IndustryPurchased {
    Amount: number;
    Coupon: string;
    CreditCardExpiration: string;
    CreditCardNr: string;
    CreditCardToken: string;
    Disabled: boolean;
    LastPaymentDate: Date;
    PartnerCode: string;
    PaymentStatus: number | string;
    PurchasedDate: Date;
    SubscriptionKey: string;
    UserID: string;
    VoucherCode: string;
}
export class IndustryTransactionInfo {
    Amount: number;
    CreditCardExpiration: string;
    CreditCardNr: string;
    CreditCardToken: string;
    OutcomeMessage: string;
    PaymentDate: Date;
    PaymentStatus: number | string;
}

export class IndustryModuleCode {
    public static CART = 'CART';
    public static SERD = 'SERD';
    public static ADSP = 'ADSP';
    //public static ADSE = 'ADSE';
    public static ASMT = 'ASMT';
    public static FBHO = 'FBHO';
    public static MANF = 'MANF';
    public static REFA = 'REFA';
    public static TRWH = 'TRWH';
    public static EDU1 = 'EDU1';
}

export class OptionAvailability {
    public static ALWAYS = 'always';
    public static OPTIONAL = 'optional';
    public static COUNT = 'count';
    public static PPT = 'ppt';
    public static EMPTY = 'empty';
    public static STANDALONE = 'standalone';
}

export class IndustryProductID {
    public static MW = 'MW';
    public static MC = 'MC';
}

export class CALPrefix {
    public static FL = 'FL';
    public static ED = 'ED';
}

export class ProductCode {
    public static MAGOWEB = 'MAWEB';
    public static MAGOCLD = 'MCLOUD';
    public static MAGO4 = 'MA4';
}
export class ModuleCode {
    public static MULT = 'MULT';
}
